import axios from "axios";
import React, { useEffect, useState } from "react";
const FreeRegistration = () => {
  const [registrationInfo, setRegistrationInfo] = useState([]);
  useEffect(() => {
    axios.get("JSON/registration.json").then((response) => {
      setRegistrationInfo(response.data[0]);
    });
  }, []);
  return (
    <>
      <section className="eschool-free-registration">
        <div className="eschool-free-reg-img">
          <img src={registrationInfo?.img} alt="#" />
        </div>
        <div className="container space z-index-common">
          <div className="row justify-content-end">
            <div className="col-lg-6">
              <div className="eschool-free-reg-content">
                <div className="eschool-free-reg-content-top">
                  <span className="free-reg-cont-sm-title">
                    {registrationInfo?.sort_title}
                  </span>
                  <h3 className="free-reg-cont-big-title">
                    {registrationInfo?.header_title}
                  </h3>
                  <p className="free-reg-cont-text">
                    {registrationInfo?.detail}
                  </p>
                </div>
                <div className="free-reg-cont-form">
                  <form action="#" method="post">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Full name</label>
                          <input type="text" name="name" required />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Email address</label>
                          <input type="email" name="email" required />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Phone number</label>
                          <input type="tel" name="number" required />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Interested class</label>
                          <select
                            className="form-select "
                            aria-label=".form-select-lg example"
                          >
                            <option selected>Select class</option>
                            <option value="1">Class One</option>
                            <option value="2">Class Two</option>
                            <option value="3">Class Three</option>
                            <option value="4">Class Four</option>
                            <option value="5">Class Five</option>
                            <option value="6">Class Six</option>
                            <option value="7">Class Seven</option>
                            <option value="8">Class Eight</option>
                            <option value="9">Class Nine</option>
                            <option value="10">Class Ten</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="free-reg-cont-button">
                          <button type="submit" className="eschool-btn">
                            Send request<i className="fi fi-rs-arrow-right"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FreeRegistration;
